import { toast } from '@oy/uidesktop';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';

export const useDevConfigFormImpl = () => {
  const data = useAppSelector(state => state.devConfig);
  const dispatch = useAppDispatch();

  const onValueChanged = (value: string, label: string) => {
    dispatch({ type: 'devConfig/set', payload: value });
    toast.success('Dev config has been updated to ' + label);
  };

  const state = { data };
  return { onValueChanged, state };
};
